import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
export interface TableColumnSettings extends DataTables.ColumnSettings {
  filterColumnHTML?: string;
}
@Component({
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss']
})
export class CustomTableComponent implements OnInit {

    /**
     * events, input or output declared
     */

  @Input()
  dtOptions: DataTables.Settings = {};

  @Input()
  columnList: TableColumnSettings[] = [];


  @Output()
  dtAjaxCall = new EventEmitter<any>();

  @Output()
    onRowInit = new EventEmitter<any>();

  dtTrigger = new Subject();
  /**
   * elements declared
   */

  @ViewChild(DataTableDirective, { read: DataTableDirective })
  dtElement: DataTableDirective;

//   @ViewChild('searchRow')
//   searchRow: ElementRef<HTMLTableRowElement>;

  @ViewChild('tableBody')
  tableBody: ElementRef<HTMLTableElement>;

  @ViewChild('table')
  table: ElementRef<HTMLTableElement>;

  @ViewChild('filterTableDiv')
  div: ElementRef<HTMLDivElement>;


  filteredData: any[] = [];

  tableWidth: number; // in px

  constructor() {}

  ngOnInit() {
      this.callServerRenderTable();
  }

  ngAfterViewInit() {
      this.dtTrigger.next();
  }


  getTableBody(): HTMLCollection {
      return this.tableBody.nativeElement.children;
  }

  get mainDiv(): HTMLDivElement {
      return this.div.nativeElement;
  }

  /**
   * Scrollable behavior added using @function setTableWidth
   * and @function updateTableOverflowStyle
   */
  setTableWidth() {
      this.tableWidth = document.body.offsetWidth;
      // try to fetch exact element width
      try {
          this.tableWidth = this.mainDiv.parentElement.parentElement.offsetWidth; // self component // parent element
      } catch (error) {
          console.error('Error: while fetching parent element offset with of table');
      }
      this.mainDiv.style.overflow = 'auto'; // added to remove shimmer of table view
      this.mainDiv.style.width = this.tableWidth.toString().concat('px');
  }
  updateTableOverflowStyle() {
      try {
          this.table.nativeElement.parentElement.style.overflow = 'auto';
          this.mainDiv.style.overflow = 'unset'; // added to remove shimmer of table view
      } catch (error) {
          console.log('Error: while setting scroll behavior to table');
      }
  }

  callServerRenderTable() {
      const componentContext: CustomTableComponent = this;
    //   const searchEle = document.getElementsByClassName('dataTables_filter');
    //   console.log(searchEle);

      this.dtOptions = {
          ...this.dtOptions,
          ajax: (dataTablesParameters: any, callback) => this.dtAjaxCall.emit({ dataTablesParameters, callback }),
          columns: this.columnList,
          initComplete() {
              componentContext.updateTableOverflowStyle();
            //   if (searchEle) {
            //     searchEle.onchange = function() {
            //         const e: any = this;
            //         if ((e.value && e.value.length > 2) || e.value.length === 0) {
            //             dtContext
            //                 .api()
            //                 .search(e.value)
            //                 .draw();
            //         }
            //     };
            // }
          },
          drawCallback() {
            this.api()
                    .rows()
                    .every(function() {
                        if (componentContext.onRowInit) {
                            componentContext.onRowInit.emit(this);
                        }
                    });
              componentContext.filteredData = this.api()
                  .rows({ filter: 'applied' })
                  .data();
          }
      };
  }

  /**
   * @description
   * It rerender the table when we need to re-initiate the API call
   * for the table already showing.
   */
  refresh() {
      console.log('in table component ..refreshing..');
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
      });
  }

  ngOnDestroy(): void {
      this.dtTrigger.unsubscribe();
  }

}
